import { downloadFilesAsZip, safeArchiveName } from "../../../../_UI/FileBatchDownload";
import { rebuildTreePaths } from "./snippets.helpers";

export const normalizeSnippetTreePayload = (payload) => {
    if (!payload || typeof payload !== "object") return null;
    if (payload.repository) return rebuildTreePaths(payload);

    const {
        folders = [],
        files = [],
        ...repository
    } = payload;

    if (!repository?.id) return null;
    return rebuildTreePaths({ repository, folders, files });
};

export const downloadSnippetTreeZip = async ({
    tree,
    loadBlob,
    fileName = null,
    successMessage = null,
    relativeToPath = "",
}) => {
    const files = Array.isArray(tree?.files) ? tree.files : [];
    if (!files.length) return false;

    const prefix = String(relativeToPath || "").replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");
    const prefixWithSlash = prefix ? `${prefix}/` : "";

    return downloadFilesAsZip({
        files,
        loadBlob,
        fileName: fileName || `${safeArchiveName(tree?.repository?.name || "repositorio")}.zip`,
        successMessage,
        errorMessage: "No se pudo descargar el repositorio completo.",
        pathForFile: (file) => {
            const fullPath = String(file?.path || file?.name || "archivo").replace(/\\/g, "/").replace(/^\/+/, "");
            if (prefixWithSlash && fullPath.startsWith(prefixWithSlash)) return fullPath.slice(prefixWithSlash.length);
            return fullPath;
        },
    });
};
